import React, { useEffect } from "react";
import "./scrolltriggers.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Box from "@mui/material/Box";
import App1 from "../../images/phone-1.svg";
import ItemIcon1 from "../../images/icons/icon-1.svg";
import ItemIcon2 from "../../images/icons/icon-2.svg";
import ItemIcon3 from "../../images/icons/icon-3.svg";
import ItemIcon4 from "../../images/icons/s-1.svg";
import ItemIcon5 from "../../images/icons/s-2.svg";
import ItemIcon6 from "../../images/icons/s-3.svg";
import ItemIcon7 from "../../images/icons/s-4.svg";
import ItemIcon8 from "../../images/icons/d-1.svg";
import ItemIcon9 from "../../images/icons/d-2.svg";
import ItemIcon10 from "../../images/icons/d-3.svg";
import ItemIcon11 from "../../images/icons/d-4.svg";
import ItemIcon12 from "../../images/icons/c-1.svg";
import ItemIcon13 from "../../images/icons/c-2.svg";
import ItemIcon14 from "../../images/icons/c-3.svg";
import ItemIcon15 from "../../images/icons/c-4.svg";
import ItemIcon16 from "../../images/icons/r-1.svg";
import ItemIcon17 from "../../images/icons/r-2.svg";
import ItemIcon18 from "../../images/icons/r-3.svg";
import ItemIcon19 from "../../images/icons/h-1.svg";
import ItemIcon20 from "../../images/icons/h-2.svg";
import ItemIcon21 from "../../images/icons/h-3.svg";
import ItemIcon22 from "../../images/icons/h-4.svg";
import ItemIcon23 from "../../images/icons/h-5.svg";
import App2 from "../../images/phone-2.svg";
import App3 from "../../images/phone-3.svg";
import App4 from "../../images/phone-4.svg";
import App5 from "../../images/phone-5.svg";

gsap.registerPlugin(ScrollTrigger);

const ScrollTriggers = () => {
  useEffect(() => {
    let ctx = gsap.context(() => {
      gsap.set(".photo:not(:first-child)", {
        opacity: 0,
        scale: 0.001,
      });

      const animation = gsap.to(".photo:not(:first-child)", {
        opacity: 1,
        scale: 1,
        duration: 0.5,
        stagger: 1,
      });

      ScrollTrigger.create({
        trigger: ".gallery",
        start: "top top",
        end: "bottom bottom",
        animation: animation,
        pin: ".rightblock",
        scrub: true,
        makers: true,
        ease: "power1.inOut",
      });
    });
    return () => ctx.revert();
  }, []);

  return (
    <React.Fragment>
      <div className="img3">
        <Box
          className="gallery"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box
            className="left"
            sx={{
              width: { xs: "100%", md: "50%" },
              marginLeft: { xs: 0, md: "auto" },
              order: { xs: 1, md: 0 },
              "& .details": {
                padding: "6%",
                height: { xs: "auto", md: "90vh" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: { xs: "100%", md: "40vw" },
                marginLeft: { xs: 0, md: "auto" },
                color: "#000",
                lineHeight: 1.1,
                // fontSize: "3rem",
                // fontWeight: 900,
              },
            }}
          >
            <Box className="details text-light-gold">
              {" "}
              <h3 className="gradient-small">Secure Communication</h3>
              <div>
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon4}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1">End-to-End Encryption (E2EE)</h5>
                    <p>
                      E2EE ensures that only the sender and recipient can access
                      data, enhancing privacy and security.
                    </p>
                  </div>
                </div>{" "}
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon5}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1">Real-Time Messaging</h5>
                    <p>
                      Real-time messaging enables instant communication between
                      users within a blockchain network, providing immediate
                      updates on transactions.
                    </p>
                  </div>
                </div>{" "}
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon6}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1">Voice and Video Calls</h5>
                    <p>
                      Voice and video calls on the blockchain enable secure,
                      peer-to-peer communication with enhanced privacy.
                    </p>
                  </div>
                </div>{" "}
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon7}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1">Group Chat</h5>
                    <p>
                      Group chat features in blockchain enable multiple users to
                      communicate simultaneously in a secure environment.
                    </p>
                  </div>
                </div>
              </div>
            </Box>
            <Box className="details text-light-gold">
              {" "}
              <h3 className="gradient-small">Decentralized Network</h3>
              <div>
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon8}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1 grediant">
                      Decentralized Network
                    </h5>
                    <p>
                      A Decentralized network distributes control across
                      multiple nodes, enhancing security and resilience. which
                      facilitates peer-to-peer interactions without a central
                      authority
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon9}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1 grediant">
                      Self-Sovereign Identity Management
                    </h5>
                    <p>
                      Self-sovereign identity (SSI) empowers users to take
                      control of their own digital identities without relying on
                      a central authority.
                    </p>
                  </div>
                </div>{" "}
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon10}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1 grediant">
                      Biometric Authentication
                    </h5>
                    <p>
                      Biometric authentication uses unique physical traits, such
                      as fingerprints or facial recognition, to verify identity
                      in Decentralized networks.
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon11}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1 grediant">
                      Hardware Root of Trust
                    </h5>
                    <p>
                      A hardware root of trust establishes a secure foundation
                      for identity and data integrity within Decentralized
                      networks.
                    </p>
                  </div>
                </div>
              </div>
            </Box>
            <Box className="details text-light-gold">
              <h3 className="gradient-small">Collaborative Mapping</h3>
              <div>
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon12}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1">Magnetic GPS</h5>
                    <p>
                      Magnetic GPS enhances location accuracy by integrating
                      magnetic field data, allowing for precise positioning in
                      environments where traditional GPS may falter.
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon13}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1">Real-Time Map Sharing</h5>
                    <p>
                      Real-time map sharing enables users to instantly update
                      and view map changes, facilitating seamless collaboration.
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon14}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1">Annotations and Markers</h5>
                    <p>
                      Annotations and markers enable users to add notes,
                      highlights, or symbols on shared maps.
                    </p>
                  </div>
                </div>{" "}
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon15}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1">Geolocation Tracking</h5>
                    <p>
                      Geolocation tracking allows users to view their real-time
                      positions on a collaborative map.
                    </p>
                  </div>
                </div>{" "}
              </div>
            </Box>
            <Box className="details text-light-gold ">
              {" "}
              <h3 className="gradient-small">Real-Time Data Sharing</h3>
              <div className="">
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon16}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1 grediant">
                      Integration with Decentralized Storage (IPFS)
                    </h5>
                    <p>
                      Integrating IPFS allows for efficient, secure storage of
                      data in real time, ensuring that shared information
                      remains Decentralized and tamper-proof.
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon17}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1 grediant">
                      Integration with Sensors and Devices
                    </h5>
                    <p>
                      Integrating sensors and devices enables the collection and
                      sharing of real-time data directly from its source.
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-4 mb-1 align-items-center">
                  <img
                    src={ItemIcon18}
                    alt="item-icon"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                  <div className="text-light-gold">
                    <h5 className="mt-3 mb-1 grediant">
                      Data Visualization and Analytics
                    </h5>
                    <p>
                      Data visualization and analytics transform raw data into
                      actionable insights using dynamic charts and dashboards.
                      These tools help users quickly identify trends and
                      patterns, enabling informed decisions based on real-time
                      information.
                    </p>
                  </div>
                </div>
              </div>
            </Box>
          </Box>
          <Box
            className="rightblock"
            sx={{
              width: { xs: "100%", md: "50%" },
              height: { xs: "auto", md: "100vh" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              order: { xs: -1, md: 1 },
            }}
          >
            <Box
              sx={{
                width: { md: "35vw" },
                height: { md: "35vw" },
                position: "relative",
                margin: "0 auto",
                "& .photo": {
                  position: { xs: "absolute", md: "absolute" },

                  width: "100%",
                  height: "100%",
                  "& img": {
                    height: "100%",
                    width: "100%",
                  },
                },
              }}
            >
              <Box className="photo">
                <img
                  src={App1}
                  alt="item-icon"
                  className="img-fluid"
                  height={400}
                  width={300}
                />
              </Box>

              <Box className="photo">
                <img
                  src={App2}
                  alt="item-icon"
                  className="img-fluid"
                  height={400}
                  width={300}
                />
              </Box>

              <Box className="photo">
                <img
                  src={App3}
                  alt="item-icon"
                  className="img-fluid"
                  height={400}
                  width={300}
                />
              </Box>
              <Box className="photo">
                <img
                  src={App4}
                  alt="item-icon"
                  className="img-fluid"
                  height={400}
                  width={300}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    </React.Fragment>
  );
};

export default ScrollTriggers;
